export default __webpack_public_path__ + "static/media/5-10-light-logo.bff15e35.png";